import { EnvironmentType } from '@/react/portainer/environments/types';

export const DeploymentType = {
  Compose: 'compose',
  Kubernetes: 'kubernetes',
} as const;

export type DeploymentType =
  (typeof DeploymentType)[keyof typeof DeploymentType];

export const DEPLOYMENT_TYPE_LABELS: Record<DeploymentType, string> = {
  [DeploymentType.Compose]: 'Docker Compose',
  [DeploymentType.Kubernetes]: 'Kubernetes',
};

// edge groups are only ever made up of edge agent environments, so
// deployment types map 1:1 to the edge-flavoured environment types
export const DEPLOYMENT_TYPE_ENVIRONMENT_TYPE: Record<
  DeploymentType,
  EnvironmentType
> = {
  [DeploymentType.Compose]: EnvironmentType.EdgeAgentOnDocker,
  [DeploymentType.Kubernetes]: EnvironmentType.EdgeAgentOnKubernetes,
};

const COMPOSE_FILENAME_PATTERN =
  /^docker-compose(\..+)?\.ya?ml$|^compose(\..+)?\.ya?ml$/i;

/**
 * Heuristic based purely on filename; a future content-based detector can
 * replace this without touching callers.
 */
export function detectDeploymentType(path: string): DeploymentType {
  const filename = path.split('/').pop() ?? path;

  return COMPOSE_FILENAME_PATTERN.test(filename)
    ? DeploymentType.Compose
    : DeploymentType.Kubernetes;
}
